module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/baiyikancha_type02.d8312f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/product_info/baiyikancha_type02.jpg
// module id = fIh+
// module chunks = 0